// extracted by css-extract-rspack-plugin
export default {"disclosure":"OBmpi_zPLWsF5Cei","panel":"HbAbHLET3XYwWBzY"};